import classnames from "classnames";
import React from "react";
import withReduxProvider from "web/react/redux-provider";
import Baustein from "web/react/components/baustein/baustein";
import shopHeaderTemplate from "templates/modules/shop/shop_header.jinja";
import profileHeaderTemplate from "templates/modules/profile_header.jinja";
import BrandAdContainer from "web/react/components/brand-ad-container/brand-ad-container";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./profile-header.css";

interface ProfileHeaderBausteinProps {
    designerLogoOnSmallScreens: boolean;
    isShopHeader?: boolean;
    profile: {
        features?: {
            pmt_brand_ads?: boolean;
        };
        brand_ad?: {
            banner_image: string;
            brand_logo: string;
            brand_name: string;
            link: string;
            mpu_image: string;
        };
    };
}

export function ProfileHeaderBaustein({
    designerLogoOnSmallScreens,
    isShopHeader,
    profile,
}: ProfileHeaderBausteinProps): JSX.Element {
    const isBrandAd = profile.features && profile.features.pmt_brand_ads;

    return (
        <>
            {isShopHeader && (
                <Baustein
                    className={classnames({ [styles.bigDesign]: designerLogoOnSmallScreens })}
                    template={shopHeaderTemplate}
                    args={{ shop_header: profile }}
                />
            )}
            {!isShopHeader && (
                <section
                    className={classnames(
                        "profile-header page-block pb-spacer--desktop pos-rel cf",
                        {
                            [styles.bigDesign]: designerLogoOnSmallScreens,
                            ["pmt-477"]: isBrandAd,
                        }
                    )}
                >
                    <Baustein
                        className="profile-header--compact-layout"
                        template={profileHeaderTemplate}
                        args={{ profile_header: profile }}
                    />
                    {profile.brand_ad && isBrandAd && (
                        <BrandAdContainer
                            bannerImage={profile.brand_ad.banner_image}
                            brandLogo={profile.brand_ad.brand_logo}
                            brandName={profile.brand_ad.brand_name}
                            link={profile.brand_ad.link}
                            mpuImage={profile.brand_ad.mpu_image}
                        />
                    )}
                </section>
            )}
        </>
    );
}

export default withReduxProvider(ProfileHeaderBaustein);
